module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAAwklEQVQokaXRP0tCURgH4KdLn7FPUBIELlqr2FrgfKnBNfwKDuEuOCuuUkvRIg7KbXmLm9x7Uu8PDpw/v/dZzlme5y+40CyjDG18NEA+0c7wjm4DqIO3LA5DjE9AxjHrBypwjfURyDpmijIES/SOgHoxYx+CAaYHINPo/mYf2uES2wSyjc4uBcEMDwnoMTp/UgXBPeYV9wv0qwbqoA2uxI9ECrTi7WAIJngqnZ/xWldOQXCHVazbVPH8H+gLN6V9bb4BOB0shWyoq6EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pay-select.png
// module id = xWnU
// module chunks = 1